module.exports = __webpack_public_path__ + "static/media/Embargo on arms import.07b423d3.png";